import React from "react";
import EditRequirements from "../components/EditRequirements/EditRequirements.tsx";

const CopyRequirementsPage = () => {
  return <EditRequirements />;
};

export default CopyRequirementsPage;
